import React, { useEffect, useState } from "react";
import { Card, FloatingLabel, Form } from "react-bootstrap";
import { usePlannerContext } from "../../../contexts/planner.contexts";
import BenefitService from "../../../services/BenefitService";
import benefitService from "../../../services/BenefitService";
import userService from "../../../services/UserService";

const EmailReport = ({ validated, submit }) => {
  const { plannerData, onChangeHandler, handleOnchangeCheckbox } =
    usePlannerContext();

  const [error, setError] = useState(false);
  const [formData, setformData] = useState({});

  useEffect(() => {
    if (
      plannerData &&
      typeof plannerData === "object" &&
      Object.keys(plannerData).length > 0
    ) {
      setformData(plannerData);
      console.log(formData);
    }
  }, [plannerData]);
  const handleSubmit = async (event) => {
    setError("");
    event.preventDefault();
    event.stopPropagation();

    if (
      formData["finalCheckToSendPdf"] &&
      formData["finalCheckToSendPdf"] == "1" &&
      formData["toEmail"]
    ) {
      const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (!emailReg.test(formData["toEmail"])) {
        setError("Please enter a valid email address.");
        return;
      }
      const payload = {
        id: formData["id"],
        profileId: formData["profileid"],
        toEmail: formData["toEmail"],
        attach_summary_report:
          formData["attach_summary_report"] == null
            ? "1"
            : formData["attach_summary_report"],
        attach_beneficiary_changes_forms:
          formData["attach_beneficiary_changes_forms"],
        attach_budget_worksheet: formData["attach_budget_worksheet"],
        attach_follow_fb_sms:
          formData["attach_follow_fb_sms"] == null
            ? "1"
            : formData["attach_follow_fb_sms"],
      };

      BenefitService.sendEmail(payload);
    }

    submit(event, formData);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        alert("File size exceeds 10MB limit.");
        return;
      }

      const uniqueFileName = `${Date.now()}-${file.name}`;

      try {
        // Send file to API for saving
        const formData = new FormData();
        formData.append("file", file);
        formData.append("bpgid", plannerData.id); // Assuming formData has an 'id' field to associate the file with
        formData.append("fileName", uniqueFileName);

        const response = await benefitService.saveAttachment(formData);

        const newFile = {
          id: response.id,
          name: response.file_name,
          size: `${(file.size / 1024).toFixed(2)} KB`,
          selected: true,
          url: response.file_path, // Assuming the API returns the file URL
        };

        setformData((prevData) => ({
          ...prevData,
          uploadedFiles: [...(prevData.uploadedFiles || []), newFile],
        }));
      } catch (error) {
        console.error("File upload failed:", error);
        alert("Failed to upload file. Please try again.");
      }
    }
  };

  const handleFileCheckboxChange = (event, index) => {
    const updatedFiles = [...formData.uploadedFiles];
    updatedFiles[index].selected = event.target.checked;
    setformData((prevData) => ({
      ...prevData,
      uploadedFiles: updatedFiles,
    }));
  };

  const handleFileDelete = async (index) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      try {
        const formDat = new FormData();

        formDat.append("id", index);

        const response = await benefitService.deleteAttachment(formDat);

        // Remove file from the list after successful deletion
        const updatedFiles = formData.uploadedFiles.filter((d, i) => {
          console.log("Comparing file ID:", d.id, "with index:", index);
          return d.id !== index;
        });
        setformData((prevData) => ({
          ...prevData,
          uploadedFiles: updatedFiles,
        }));
      } catch (error) {
        console.error("File deletion failed:", error);
      }
    }
  };

  return (
    <>
      <Card.Body className="email-report-section">
        <Form
          className="subform"
          name="emailReportForm"
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
        >
          <div className="qs-box single-screen">
            <h1 className="question">Reports &amp; Documents</h1>
            <div className="input-div">
              <label className="input-label">
                <input
                  type="checkbox"
                  className="label-check-fa allow_email_correspondence report-section-input"
                  name="finalCheckToSendPdf"
                  checked={
                    formData["finalCheckToSendPdf"] === "1" ? true : false
                  }
                  onChange={(event) => {
                    handleOnchangeCheckbox(
                      event,
                      event.target.checked ? "1" : "0",
                      setformData
                    );
                  }}
                />
                <span>
                  Check to allow email correspondence and receive a summary
                  report of your planner.{" "}
                  <a
                    className="email-report-a"
                    target="_blank"
                    href="https://myfedbenefitshelp.com/privacy/ "
                  >
                    Privacy policy
                  </a>
                  .
                </span>
              </label>
            </div>

            {formData.finalCheckToSendPdf == "1" && (
              <div className="email-area">
                <div className="col-md-12">
                  <div className="mt-2 col-md-6 col-md-offset-3 email-report-floating-label">
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Email:"
                      className="mb-2 email-report-floating-placeholder required-input"
                    >
                      <Form.Control
                        type="email"
                        name="toEmail"
                        className="tsp-2-textbox"
                        placeholder="Age To Begin"
                        value={formData.toEmail}
                        onChange={(event) =>
                          onChangeHandler(event, setformData)
                        }
                        isInvalid={validated && !formData.toEmail}
                        autoComplete="off"
                        required
                      />
                    </FloatingLabel>
                    {error && <p className="red fw-bold">{error}</p>}
                  </div>
                </div>
                <div className="attach-email-wrapper">
                  <p className="attach-email-p">Attachments to be Emailed:</p>
                  <ul className="attach-email-ul">
                    <li>
                      <label className="attach-email-label">
                        <input
                          type="checkbox"
                          className="label-check-fa attach-email-input"
                          checked={
                            formData.attach_budget_worksheet == "1"
                              ? true
                              : false
                          }
                          onClick={(e) =>
                            handleOnchangeCheckbox(
                              e,
                              e.target.checked ? "1" : "0",
                              setformData
                            )
                          }
                          name="attach_budget_worksheet"
                          autoComplete="off"
                        />{" "}
                        Budget Worksheet
                      </label>
                    </li>
                    <li>
                      <label className="attach-email-label">
                        <input
                          type="checkbox"
                          className="label-check-fa attach-email-input"
                          checked={
                            formData.attach_beneficiary_changes_forms == "1"
                              ? true
                              : false
                          }
                          onClick={(e) =>
                            handleOnchangeCheckbox(
                              e,
                              e.target.checked ? "1" : "0",
                              setformData
                            )
                          }
                          name="attach_beneficiary_changes_forms"
                          autoComplete="off"
                        />{" "}
                        Beneficiary Changes Forms (TSP and FEGLI)
                      </label>
                    </li>
                    <li>
                      <label className="attach-email-label">
                        <input
                          type="checkbox"
                          name="attach_summary_report"
                          className="label-check-fa attach-email-input"
                          checked={
                            formData.attach_summary_report == "1" ||
                            formData.attach_summary_report == null
                              ? true
                              : false
                          }
                          onChange={(event) => {
                            handleOnchangeCheckbox(
                              event,
                              event.target.checked ? "1" : "0",
                              setformData
                            );
                          }}
                        />
                        <span>Summary Report</span>
                      </label>
                    </li>
                  </ul>
                  <p className="attach-email-p">Stay Informed:</p>
                  <ul className="attach-email-ul">
                    <li>
                      <label className="attach-email-label">
                        <input
                          type="checkbox"
                          name="attach_follow_fb_sms"
                          className="label-check-fa attach-email-input"
                          checked={
                            formData.attach_follow_fb_sms == "1" ||
                            formData.attach_follow_fb_sms == null
                              ? true
                              : false
                          }
                          onChange={(event) => {
                            handleOnchangeCheckbox(
                              event,
                              event.target.checked ? "1" : "0",
                              setformData
                            );
                          }}
                        />
                        <span>
                          Receive an SMS to follow us on Facebook{" "}
                          <i className="fa fa-thumbs-o-up"></i>
                        </span>
                      </label>
                    </li>
                  </ul>

                  {userService.getAccess().user_id === 61 && (
                    <>
                      <p className="attach-email-p">Additional Attachments:</p>
                      <div className="additional-agent-attachments">
                        <div
                          className="btn-upload mt-3 mb-3"
                          onClick={(e) => {
                            e.preventDefault();
                            document.getElementById("fileUploadInput").click();
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="up-part">UPLOAD FILE</div>
                          <div className="ris-part">
                            {" "}
                            (PDF, DOCX, JPG - MAX 10MB)
                          </div>
                        </div>
                        <input
                          type="file"
                          id="fileUploadInput"
                          style={{ display: "none" }}
                          accept=".pdf,.docx,.xlsx,.jpg,.png"
                          onChange={(event) => handleFileUpload(event)}
                        />
                        {formData.uploadedFiles &&
                        formData.uploadedFiles.length > 0 ? (
                          <table className="attach-email-ul">
                            {formData.uploadedFiles.map((file, index) => (
                              <tr key={index}>
                                <td>
                                  <label className="attach-email-label">
                                    <input
                                      type="checkbox"
                                      className="label-check-fa attach-email-input"
                                      checked={true}
                                      autoComplete="off"
                                    />
                                  </label>
                                </td>
                                <td>
                                  <label className="attach-email-label">
                                    {file.name}
                                  </label>
                                </td>
                                <td>
                                  <label className="attach-email-label">
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleFileDelete(file.id);
                                      }}
                                    >
                                      Remove
                                    </a>
                                  </label>
                                </td>
                              </tr>
                            ))}
                          </table>
                        ) : (
                          <p className="placeholder-message">
                            No files uploaded yet.
                          </p>
                        )}
                      </div>
                    </>
                  )}
                </div>
                {validated && (
                  <div className="red-text text-center mt-2 mb-2">
                    *Complete required fields to continue
                  </div>
                )}
                <div className="complete-planner-wrapper">
                  <button
                    className="btn-next btn question-next"
                    id="emailSummaryReport"
                    type="submit"
                  >
                    Complete Planner
                  </button>
                </div>
              </div>
            )}

            {formData.finalCheckToSendPdf !== "1" && (
              <div className="complete-planner-wrapper">
                <button
                  className="btn-next btn question-next"
                  id="emailSummaryReport"
                  type="submit"
                >
                  Complete Planner
                </button>
              </div>
            )}
          </div>
        </Form>
      </Card.Body>
    </>
  );
};

export default EmailReport;
